<template>
  <div style="margin-bottom: 10%">
    <breadcrumb v-bind:path2="orderDetail.SONum"></breadcrumb>
    <div class="account">
      <div class="main-content">
        <!-- login  -->
        <div v-show="loggedIn===true" class="page-width">
          <div class="section-header text-center">
            <h1>{{ $t('orderDetail') }}</h1>
            <p>
              <router-link to="/account">{{ $t('returnAccount') }}</router-link>
            </p>
            </div>
          <div class="grid">
            <div class="grid__item medium-up--two-thirds">
              <!-- sales order details -->
              <h2>{{ $t('orderNo') }} {{orderDetail.SONum}}</h2>
              <p>{{ $t('placedOn') }}: {{getOrderTime(orderDetail.OrderDate)}}</p>
              <p>{{ $t('estimateDeliveryDate') }}: {{getEstTime(orderDetail.DispatchDate)}}&nbsp;{{TimeRange}}</p>
              <table class="responsive-table">
                <thead>
                  <tr>
                    <th>{{ $t('product') }}</th>
                    <th>SKU</th>
                    <th>{{ $t('price') }}</th>
                    <th>{{ $t('quantity') }}</th>
                    <th>{{ $t('total') }}</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in orderDetail.Sales_Order_Line" data-index="index" :key="index" class="responsive-table__row">
                  <td data-label="Product">{{item.Name}}</td>
                  <td data-label="SKU">{{item.RefNum}}</td>
                  <td data-label="Price">${{getAmount(item.UnitPrice)}}</td>
                  <td data-label="Quantity">{{item.Quantity}}</td>
                  <td data-label="Total">${{getAmount(item.TotalPrice)}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="responsive-table__row">
                  <td colspan='4' class='small--hide'>{{ $t('subtotal') }}</td>
                  <td data-label="Subtotal">${{getAmount(orderDetail.TotalPrice)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('promotion') }}</td>
                  <td data-label="Savings">-${{getAmount(orderDetail.Savings)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('sharingDiscount') }}</td>
                  <td data-label="ShareCreditAmount">-${{getAmount(orderDetail.ShareCreditAmount)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('tax') }}</td>
                  <td data-label="Tax">${{getAmount(orderDetail.TaxAmount)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('shippingStandardShipping') }}</td>
                  <td data-label="Shipping">${{getAmount(orderDetail.Delivery)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('total') }}</td>
                  <td data-label="Total">${{getAmount(orderDetail.GrandTotal)}}</td>
                </tr>
              </tfoot>
            </table>
            <!-- end sales order details -->
            <!-- sales invoice details -->
            <h2 v-if="hasInvoice">{{ $t('Invoice') }}</h2>
            <table v-if="hasInvoice" class="responsive-table">
              <thead>
                <tr>
                  <th>{{ $t('product') }}</th>
                  <th>SKU</th>
                  <th>{{ $t('price') }}</th>
                  <th>{{ $t('quantity') }}</th>
                  <th>{{ $t('total') }}</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in invoiceDetail.Sales_Order_Line" data-index="index" :key="index" class="responsive-table__row">
                <td data-label="Product">{{item.Name}}</td>
                <td data-label="SKU">{{item.RefNum}}</td>
                <td data-label="Price">${{getAmount(item.UnitPrice)}}</td>
                <td data-label="Quantity">{{item.Quantity}}</td>
                <td data-label="Total">${{getAmount(item.TotalPrice)}}</td>
              </tr>
              </tbody>
              <tfoot>
                <tr class="responsive-table__row">
                  <td colspan='4' class='small--hide'>{{ $t('subtotal') }}</td>
                  <td data-label="Subtotal">${{getAmount(invoiceDetail.TotalPrice)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('promotion') }}</td>
                  <td data-label="Savings">-${{getAmount(invoiceDetail.Savings)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('sharingDiscount') }}</td>
                  <td data-label="ShareCreditAmount">-${{getAmount(invoiceDetail.ShareCreditAmount)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('shippingStandardShipping') }}</td>
                  <td data-label="Shipping">${{getAmount(invoiceDetail.Delivery)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('tax') }}</td>
                  <td data-label="Tax">${{getAmount(invoiceDetail.TaxAmount)}}</td>
                </tr>
                <tr>
                  <td colspan='4' class='small--hide'>{{ $t('total') }}</td>
                  <td data-label="Total">${{getAmount(invoiceDetail.GrandTotal)}}</td>
                </tr>
               </tfoot>
            </table>
            <!-- end sales invoice details -->
          </div>
          <div class="grid__item medium-up--one-third">
            <hr class="medium-up--hide">
              <!--<h3>Billing Address</h3>
              <p>
                <strong>Payment Status:</strong>
                 {{PaymentStatus}}
              </p>
              <p>
                <br>
                <br>
                <br>
              </p>-->
              <h3>{{ $t('shippingAddress') }}</h3>
              <p>
                <strong>{{ $t('paymentStatus') }}:</strong>
                {{PaymentStatus}}
                <br>
                <strong>{{ $t('fulfillmentStatus') }}:</strong>
                {{SaleStatus}}
              </p>
              <p>
                {{orderDetail.Shipping_Address.FirstName}} {{orderDetail.Shipping_Address.LastName}}
                <br>
                {{orderDetail.Shipping_Address.Telephone}}
                <br>
                {{orderDetail.Shipping_Address.Street}}
                <br>
                {{orderDetail.Shipping_Address.City}} {{orderDetail.Shipping_Address.State}}
                <br>
                {{orderDetail.Shipping_Address.Country}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import breadcrumb from '../components/breadcrumb';
import moment from 'moment';
import Router from '../router'
  export default {
    name: "order",
    loaded: false,
    components: {
        breadcrumb,
    },
    data(){
      return{
        path2: '',
        orderDetail: {
          Sales_Order_Line: [],
          Shipping_Address: {},
          FinalPrice:'',
          GrandTotal:'',
          Delivery:'',
          SONum: '',
          OrderDate:'',
          DispatchDate:'',
          PaymentStatus:'',
          SaleStatus:'',
          TaxAmount: '',
          TotalPrice: '',
          TimeRange: '',
          Savings: '',
          ShareCreditAmount: '',
        },
        hasInvoice: false,
        invoiceDetail: {
          Sales_Order_Line: [],
          Shipping_Address: {},
          FinalPrice:'',
          GrandTotal:'',
          Delivery:'',
          SONum: '',
          OrderDate:'',
          DispatchDate:'',
          PaymentStatus:'',
          SaleStatus:'',
          TaxAmount: '',
          TotalPrice: '',
          TimeRange: '',
          Savings: '',
          ShareCreditAmount: '',
        },
      }
    },
    methods:{
      ...mapActions('orders', ['fetchOrderByTimeFrame','fetchSODetails','fetchSIDetails']),
      fetchOrderDetail(orderId) {
        this.fetchSODetails(orderId)
        .then(res => {
          this.orderDetail = res.data;
        })
        .catch(err => {
          console.log('fetchOrderDetail error: ', err);
        })
      },
      fetchInvoiceDetail(orderId) {
        this.fetchSIDetails(orderId)
        .then(res => {
          this.invoiceDetail = res.data;
          this.hasInvoice = true;
        })
        .catch(err => {
          this.hasInvoice = false;
          console.log('fetchInvoiceDetail error: ', err);
        })
      },
      getOrderTime(OrderDate){
        return moment(OrderDate).format('MMMM Do YYYY, h:mm:ss a');
      },
      getEstTime(DispatchDate){
        return moment(DispatchDate).format('MMMM Do YYYY');
      },
      getAmount(price){
        return parseFloat(price).toFixed(2); 
      },
    },
    computed: mapState({
      loggedIn: state => state.auth.loggedIn,
      orderTimeFrame: state => state.order.orderTimeFrame
    }),
    watch: {
      $route() {
        this.$router.go(this.$route);
      }
    },
    mounted: function() {
      this.orderId = this.$route.params.order_id;
      this.fetchOrderDetail(this.orderId);
      this.fetchInvoiceDetail(this.orderId);
    },
    created: function(){

    }
  }
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/order.less";
@import "../assets/css/account.less";
</style>



// WEBPACK FOOTER //
// src/view/order.vue